export type CollapseOnOption =
  | 'factuality'
  | 'temporality'
  | 'role'
  | 'time'
  | 'event_id'
  | 'participant';

export type EventTemporality = 'past' | 'present' | 'future';

export type EventFactuality =
  | 'FACT'
  | 'COUNTERFACT'
  | 'PROBABLE'
  | 'COUNTERPROBABLE'
  | 'POSSIBLE'
  | 'COUNTERPOSSIBLE'
  | 'NONE'
  | 'UNKNOWN';

export type EventNegation = 0 | 1;

export type EventTimeRangeMode = 'event_date_time' | 'publish_time';

export type InclusionFilterInput<T> = T[] | { include?: T[]; exclude?: T[] };

export type EventTemporalityWire =
  | 'PAST'
  | 'PRESENT'
  | 'FUTURE'
  | 'UNKNOWN'
  | 'NONE';

export interface EventsTimeRange {
  date_from: string;
  date_to: string;
}

export interface EventsEventFilter {
  event_ids?: InclusionFilterInput<string>;
  event_participants?: InclusionFilterInput<string>;
  factuality?: InclusionFilterInput<EventFactuality>;
  temporality?: InclusionFilterInput<EventTemporalityWire>;
  negation?: InclusionFilterInput<boolean>;
  participant_roles?: InclusionFilterInput<string>;
  time_range_mode?: EventTimeRangeMode;
}

export interface EventsRequestBody {
  time_range: EventsTimeRange;
  event_filter?: EventsEventFilter;
  project?: string;
  language_filter?: InclusionFilterInput<string>;
  collapse_on?: CollapseOnOption[];
}

// `events` is a tuple matrix; `columns` names the tuple positions.
// Listed `collapse_on` axes are removed from each row.
export interface CollapsedEventsResponse {
  events: (string | number)[][];
  columns: string[];
}

export const FACTUALITY_INT_TO_ENUM: Record<number, EventFactuality> = {
  0: 'FACT',
  1: 'COUNTERFACT',
  2: 'POSSIBLE',
  3: 'COUNTERPOSSIBLE',
  4: 'PROBABLE',
  5: 'COUNTERPROBABLE',
  6: 'UNKNOWN',
  7: 'NONE',
};

// Temporality is returned in the column named `time`.
export const TEMPORALITY_INT_TO_ENUM: Record<number, EventTemporalityWire> = {
  0: 'PAST',
  1: 'PRESENT',
  2: 'FUTURE',
  3: 'UNKNOWN',
  4: 'NONE',
};
